import Swiper from 'swiper';
import {Navigation, Pagination, EffectCreative, Autoplay } from "swiper/swiper.esm";
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay]);

const supportSlider  = new Swiper('.support-slider',{
    spaceBetween: 188,
    loop: true,
    freeMode: true,
    slidesPerView: 'auto',
    speed: 11000,
    autoplay: {
        delay: 0,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
        waitForTransition: true,
        stopOnLastSlide: false,
    },
})